export default __webpack_public_path__ + "static/media/map.5be47470.png";